// React components entry point
// This file exports all React components and utilities for use in the Angular app

export { MuiProvider } from './styles/MuiProvider';
export { registerReactComponent, getReactComponent } from './reactBridge';

// Import the Angular module to ensure it's registered
import { registerReactComponent } from './reactBridge';

// Report components
import { StudentProgress } from './pages/reports/StudentProgress/StudentProgress';
export { StudentProgress };

import { ReportPickerComponent } from './components/reports/ReportPickerComponent/ReportPickerComponent';
export { ReportPickerComponent };

import { ReportPicker } from './pages/reports/ReportPicker/ReportPicker';
export { ReportPicker };

import ReportNavigationComponent from './components/reports/ReportNavigationComponent/ReportNavigationComponent';
export { ReportNavigationComponent };

import AlertComponent from './components/core/AlertComponent/AlertComponent';
export { AlertComponent };

import ProgressComponent from './components/core/ProgressComponent/ProgressComponent';
export { ProgressComponent };

import FullPageReportComponent from './components/reports/FullPageReportComponent/FullPageReportComponent';
export { FullPageReportComponent };

// Experience components
import { Standards } from './components/Experiences/Standards/Standards';
export { Standards };

import { MasterTemplateCard as ExperienceCard } from './components/Experiences/Cards/MasterTemplateCard/MasterTemplateCard';
export { ExperienceCard };

import { Assigned } from './pages/experiences/Assigned/Assigned';
export { Assigned };

// Experience pages
import { Masters } from './pages/experiences/Masters/Masters';
export { Masters };

import { Academy } from './pages/academy/Academy/Academy';
export { Academy };

import { Skillset } from './pages/academy/Skillset/Skillset';
export { Skillset };

import { QuizNavigator } from './components/quiz/QuizNavigator/QuizNavigator';
export { QuizNavigator };

import { TextToSpeech } from './components/core/Accessibility/TextToSpeech/TextToSpeech';
export { TextToSpeech };
import { TierBadge } from './components/academy/TierBadge/TierBadge';
export { TierBadge };

import { SignupPage } from './pages/signup/SignupPage/SignupPage';
export { SignupPage };

// Register React components for use in Angular templates
registerReactComponent('StudentProgress', StudentProgress);
registerReactComponent('ReportPicker', ReportPickerComponent);
registerReactComponent('ReportPickerPage', ReportPicker);
registerReactComponent('ReportNavigationComponent', ReportNavigationComponent);
registerReactComponent('AlertComponent', AlertComponent);
registerReactComponent('ProgressComponent', ProgressComponent);
registerReactComponent('FullPageReportComponent', FullPageReportComponent);
registerReactComponent('Standards', Standards);
registerReactComponent('ExperienceCard', ExperienceCard);
registerReactComponent('Assigned', Assigned);
registerReactComponent('Masters', Masters);
registerReactComponent('Academy', Academy);
registerReactComponent('Skillset', Skillset);
registerReactComponent('QuizNavigator', QuizNavigator);
registerReactComponent('TextToSpeech', TextToSpeech);
registerReactComponent('TierBadge', TierBadge);
registerReactComponent('SignupPage', SignupPage);
